var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.803516 13.2912C0.958516 13.5245 1.21935 13.6654 1.49935 13.6654H13.9993C14.3327 13.6654 14.6343 13.467 14.7652 13.1604L17.2652 7.32703C17.32 7.20031 17.3423 7.06195 17.3303 6.92442C17.3182 6.78689 17.2721 6.65453 17.1961 6.53927C17.1202 6.42401 17.0167 6.32948 16.895 6.2642C16.7734 6.19893 16.6374 6.16496 16.4993 6.16536H15.666V3.66536C15.666 2.7462 14.9185 1.9987 13.9993 1.9987H8.45352L6.32352 0.332031H2.33268C1.41352 0.332031 0.666016 1.07953 0.666016 1.9987V12.832H0.671849C0.669992 12.9947 0.715761 13.1543 0.803516 13.2912V13.2912ZM13.9993 3.66536V6.16536H3.99935C3.66602 6.16536 3.36435 6.3637 3.23352 6.67036L2.33268 8.77286V3.66536H13.9993Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.24bf6b676eb4f0497aac2f40d11fea15.svg";
export { ForwardRef as ReactComponent };